module.exports = __webpack_public_path__ + "img/profile-avatar-circle-full.85512d4d.jpg";